var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5496 5.5583C14.6667 5.67549 14.7324 5.83434 14.7324 5.99997C14.7324 6.16559 14.6667 6.32444 14.5496 6.44163L9.54964 11.4416C9.49242 11.503 9.42342 11.5523 9.34675 11.5864C9.27009 11.6206 9.18733 11.639 9.10341 11.6405C9.01949 11.6419 8.93613 11.6265 8.85831 11.5951C8.78048 11.5636 8.70979 11.5168 8.65044 11.4575C8.59109 11.3981 8.5443 11.3275 8.51287 11.2496C8.48143 11.1718 8.466 11.0884 8.46748 11.0045C8.46896 10.9206 8.48733 10.8378 8.52149 10.7612C8.55565 10.6845 8.6049 10.6155 8.66631 10.5583L12.5996 6.62497H0.774638C0.608877 6.62497 0.449905 6.55912 0.332696 6.44191C0.215486 6.3247 0.149638 6.16573 0.149638 5.99997C0.149638 5.8342 0.215486 5.67523 0.332696 5.55802C0.449905 5.44081 0.608877 5.37497 0.774638 5.37497H12.5996L8.66631 1.44163C8.6049 1.38441 8.55565 1.31541 8.52149 1.23875C8.48733 1.16208 8.46896 1.07932 8.46748 0.995401C8.466 0.911481 8.48143 0.828124 8.51287 0.7503C8.5443 0.672477 8.59109 0.601782 8.65044 0.542433C8.70979 0.483084 8.78048 0.436297 8.85831 0.404863C8.93613 0.373429 9.01949 0.357992 9.10341 0.359472C9.18733 0.360953 9.27009 0.379321 9.34675 0.413481C9.42342 0.447641 9.49242 0.496893 9.54964 0.558298L14.5496 5.5583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.18a61dfc74a72b4f19f76895cdb0167a.svg";
export { ForwardRef as ReactComponent };